import axios from 'axios';
import { api } from '../../config/constants';
import { options } from '../../helpers/cookieHelper';

// Plain promise-returning functions (not dispatched action creators): the
// consent screen consumes the returned redirect URL directly and navigates
// the top-level browser to it, so there is no Redux state to update.

export function oauthAllow(requestId) {
  return axios
    .post(api.OAUTH_AUTHORIZE_COMPLETE, { request_id: requestId }, options)
    .then(function (res) {
      return res.data.redirect_to;
    });
}

export function oauthDeny(requestId) {
  return axios
    .post(api.OAUTH_AUTHORIZE_DENY, { request_id: requestId }, options)
    .then(function (res) {
      return res.data.redirect_to;
    });
}
